import { getL10nNumber } from '@travel/i18n';

import type { MarketType } from '@travel/i18n';
import type { DecimalValue } from '@travel/i18n/src/config/types';

/* default formatter for display of numbers  */
export const defaultNumberFormatter = (
  market: MarketType,
  decimals = 0,
  shouldDisplayOriginalValue = false,
) => {
  return (value: DecimalValue) => {
    return getL10nNumber(market.marketCode, value, decimals, shouldDisplayOriginalValue);
  };
};
